import { render, staticRenderFns } from "./UnitsFinancieel.vue?vue&type=template&id=1332302d"
import script from "./UnitsFinancieel.vue?vue&type=script&lang=js"
export * from "./UnitsFinancieel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports